import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const STORAGE_KEY = "anotador";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const API = `${BACKEND_URL}/api/annotations`;

const KONAMI_SECUENCIA = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "KeyB",
  "KeyA",
];

export function isAnotadorActivo() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function activarAnotador(activo = true) {
  try {
    if (activo) {
      window.localStorage.setItem(STORAGE_KEY, "true");
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
    window.dispatchEvent(new Event("anotador:cambio"));
  } catch {
    // ignore
  }
}

export function useAnotador() {
  const [activo, setActivo] = useState(() => isAnotadorActivo());
  useEffect(() => {
    const onChange = () => setActivo(isAnotadorActivo());
    window.addEventListener("storage", onChange);
    window.addEventListener("anotador:cambio", onChange);
    return () => {
      window.removeEventListener("storage", onChange);
      window.removeEventListener("anotador:cambio", onChange);
    };
  }, []);
  return activo;
}

export function useAnotadorKonamiShortcut() {
  const bufferRef = useRef([]);
  useEffect(() => {
    const onKey = (e) => {
      const target = e.target;
      const tag = target?.tagName;
      if (
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        target?.isContentEditable
      ) {
        return;
      }
      bufferRef.current = [...bufferRef.current, e.code].slice(
        -KONAMI_SECUENCIA.length,
      );
      const buf = bufferRef.current;
      if (
        buf.length === KONAMI_SECUENCIA.length &&
        buf.every((c, i) => c === KONAMI_SECUENCIA[i])
      ) {
        bufferRef.current = [];
        const yaActivo = isAnotadorActivo();
        activarAnotador(!yaActivo);
        if (yaActivo) {
          toast("Anotador desactivado");
        } else {
          toast.success("Anotador activado", {
            description: "Modo anotación habilitado",
          });
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}

export async function crearAnotacion(payload) {
  const { data } = await axios.post(API, payload);
  return data;
}

export async function listarAnotaciones({ veredicto, limit = 50 } = {}) {
  const params = {};
  if (veredicto) params.veredicto = veredicto;
  if (limit) params.limit = limit;
  const { data } = await axios.get(API, { params });
  return data;
}

export async function eliminarAnotacion(id) {
  const { data } = await axios.delete(`${API}/${encodeURIComponent(id)}`);
  return data;
}
